import type SignalAdNetwork from "app/pages/sales-intelligence/sub-modules/signals/models/ad-network/SignalAdNetwork";
import type TechnologySignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalFilters";
import { TechnologySignalTechnologiesFiltersKey } from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalTechnologiesFiltersKey";
import type { ICountryService } from "app/services/CountryService";

export const buildCountriesTrackingValue = (
    countriesIds: ReadonlyArray<number>,
    countryService: ICountryService,
): ReadonlyArray<string> => {
    return countriesIds.map((countryId) => countryService.getCountryById(countryId)?.text).filter(Boolean);
};

export const buildTechnologiesTrackingValue = (
    technologies: Partial<TechnologySignalFilters>,
): ReadonlyArray<string> => {
    let technologiesNames: ReadonlyArray<string> = [];

    for (const key of Object.values(TechnologySignalTechnologiesFiltersKey)) {
        const value = technologies[key] ?? [];

        if (Array.isArray(value) && value.length > 0) {
            technologiesNames = [...technologiesNames, ...value];
        }
    }

    //TODO use createTrackingEventName instead of replacing here
    return technologiesNames.map((n) => n.replace(/\//g, "-"));
};

export const buildAdNetworksTrackingValue = (
    adNetworkIds: ReadonlyArray<number>,
    options: ReadonlyArray<SignalAdNetwork>,
): ReadonlyArray<string> => {
    return options.reduce((adNetworkNames, { id, name }) => {
        if (adNetworkIds.includes(id)) {
            adNetworkNames = [...adNetworkNames, name];
        }

        return adNetworkNames;
    }, [] as ReadonlyArray<string>);
};
